export const CHART_COLORS = [
  "#4B5675", // muted dark blue
  "#7986CB", // soft indigo
  "#64B5F6", // light blue
  "#81C784", // soft green
  "#FFB74D", // warm orange
  "#AED581", // light green
  "#BA68C8", // soft violet
  "#FF8A65", // coral
];
